import { action } from '@ember/object';
import Component from '@glimmer/component';
import type TagModel from 'frontend/models/tag';

export interface SearchPageFiltersTagsComponentArgs {
  tags: TagModel[];
  updateTags: (id: string) => unknown;
}

export default class SearchPageFiltersTagsComponent extends Component<SearchPageFiltersTagsComponentArgs> {
  getTagById = (id: string) =>
    this.args.tags.find((tag: TagModel) => tag.id === id);

  @action
  updateTags(tag: TagModel) {
    this.args.updateTags(tag.id);
  }
}
